module.exports = __webpack_public_path__ + "static/media/spinach-cake.5ee09f34.jpg";